
import { AnalyticsInsight } from '@/types/analytics';
import { dataAnalyticsRobot } from './analytics/DataAnalyticsRobot';

export const AnalyticsService = {
  getUsageData: async () => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1200));
    return {
      chartData: [
        { name: 'Adv. Calc', value: 120 },
        { name: 'SmartBuy', value: 85 },
        { name: 'Reports', value: 65 },
        { name: 'Brochure', value: 42 },
      ],
      totalSessions: 124,
      totalInteractions: 589,
    };
  },
  
  getTrendsData: async () => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      pieData: [
        { name: 'Home Price', value: 400 },
        { name: 'Down Pmt.', value: 300 },
        { name: 'Int. Rate', value: 180 },
        { name: 'Loan Term', value: 120 },
      ],
      priceData: [
        { month: 'Jan', amount: 480000 },
        { month: 'Feb', amount: 495000 },
        { month: 'Mar', amount: 510000 },
        { month: 'Apr', amount: 505000 },
        { month: 'May', amount: 520000 },
        { month: 'Jun', amount: 535000 },
      ],
    };
  },
  
  getInsights: async (): Promise<AnalyticsInsight[]> => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    return [
      {
        id: 'insight-1',
        title: 'Higher Down Payment Recommendation',
        description: 'You frequently adjust the down payment. Increasing it could lower your monthly payments significantly.',
        type: 'Optimization',
        createdAt: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
        read: false,
      },
      {
        id: 'insight-2',
        title: 'Market Trend: Rising Prices',
        description: 'Average home prices in your searches have increased by 5% over the last 3 months.',
        type: 'Market',
        createdAt: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString(),
        read: true,
      },
      {
        id: 'insight-3',
        title: 'New Feature Usage: SmartBuy Analyzer',
        description: 'You\'ve started using the SmartBuy Analyzer. Explore cost scenarios to maximize its value.',
        type: 'Usage',
        createdAt: new Date().toISOString(),
        read: false,
      },
    ];
  },

  // New opportunity analysis methods
  getOpportunityAnalysis: async () => {
    try {
      // Start the robot if not already running
      if (!dataAnalyticsRobot.getStatus().isRunning) {
        await dataAnalyticsRobot.start();
      }
      
      const analysis = await dataAnalyticsRobot.analyzeTrends();
      return analysis;
    } catch (error) {
      console.error('Failed to get opportunity analysis:', error);
      throw error;
    }
  },

  searchOpportunities: async (query: string, filters?: any) => {
    try {
      // Start the robot if not already running
      if (!dataAnalyticsRobot.getStatus().isRunning) {
        await dataAnalyticsRobot.start();
      }
      
      const results = await dataAnalyticsRobot.searchAndAnalyze(query, filters);
      return results;
    } catch (error) {
      console.error('Failed to search opportunities:', error);
      throw error;
    }
  },

  getAnalyticsRobotStatus: () => {
    return dataAnalyticsRobot.getStatus();
  }
};
